import { SdkEvents } from "sdk/index";
import { StoreModel } from '../../models/Index';

export default function printReceipt(Store: StoreModel, data: any) {
    const request = data.data as PrintReceiptRequest;

    if (!request.receiptData) {
        const error = new Error("Trying to print empty receipt");
        console.error(error, request);

        throw error;
    }

    return Store.shellClient.printReceipt(request.receiptData)
        .finally(() => {
            Store.sdk.events.emit(SdkEvents.CashAcceptorStarted, {});
        });;
}


export interface PrintReceiptRequest {
    transactionId: number;
    amount: number;

    receiptData: string;
}
